import React, { useEffect, useMemo, useState } from 'react'
import { Wrapper, AvatarProfile, Btn } from '../../_components'
import Table from '../../_components/Table'
import Axios from 'axios'
import moment from 'moment'
import { capitalize, formatCurrency } from '../../_utils'

const NameField = record => {
    let Name = record.value?.split(" ")

    return (
        <div className="flex flex-col items-start justify-center">
            <AvatarProfile bold label={`${capitalize( Name[ 0 ] )} ${capitalize( Name[ 1 ] )}`}/>
        </div>
    )
}

export default function MembershipList() {
    const Columns = useMemo(
    () => [
        {
            Header: "Date Created",
            accessor: "date"
        },
        {
            Header: "Name",
            accessor: "farmerName",
            Cell: NameField
        },
        // {
        //     Header: "Season",
        //     accessor: "season"
        // },
        {
            Header: "Plot No.",
            accessor: "plot"
        },
        {
            Header: "Block No.",
            accessor: "block"
        },
        {
            Header: "FFSG",
            accessor: "group"
        },
        {
            Header: "Amount Paid",
            accessor: "amountPaid"
        } ]
    )
    const [ records, setRecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    
    useEffect( () => {
        if( loading ) {
            fetchAllPayment()
        }
    },[ loading ])

    const fetchAllPayment = async() => {
        try {
            const response = await Axios.get( `https://mis.nec.go.ug/api/auth/farmer_payment` )
            if( response.data ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        amountPaid: formatCurrency( result.amountPaid ),
                        type: result.type,
                        farmerCode: result.farmerCode,
                        farmerName: result.farmerName,
                        id: ( index + 1 ),
                        plot: result.plotNumber,
                        block: result.blockNo,
                        group: result.ffsg,
                        shares: result.sharesNumber,
                        created_at: result.created_at
                    }
                } ).filter( record => {
                    return record.type === "membership"
                } ).sort( ( a, b ) => {
                    return moment( b.created_at ).format( "YYYYMMDD" ) - moment( a.created_at ).format( "YYYYMMDD" )
                } )
                
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            setLoading( false )    
        }
    }
    
    return (
    <Wrapper>
     <div className="flex flex-col">
        <h2 className="md:text-3xl lg:text-3xl text-base px-2">
            {`Membership Fees - Farmers Payment List`}
        </h2>
        {loading ? (
            <div className="flex items-center justify-center">
                <span className="text-center text-base">
                    {`Loading Farmer Payment List for ${localStorage.getItem( "scheme")} Scheme...`}
                </span>
            </div>
        ) :
        ( 
        <>
            <Table
                label="Payment List"
                columns={Columns}
                data={records}
                hidePagination={false} /> 
        </>
        ) }
     </div>
    </Wrapper>
  )
}
